export default "__VITE_ASSET__CTRVIvxG__"